import request from '@/router/axios'
import env from '@/config/env'

// 中奖记录
export function postRecordPage(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/record/page',
    method: 'post',
    data
  })
}

// 奖品池
export function postPrizesPage(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/prizes/page',
    method: 'post',
    data
  })
}

// 新增奖品池
export function postPrizesAdd(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/prizes/add',
    method: 'post',
    data
  })
}

// 奖品池-编辑奖品
export function postPrizesEdit(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/prizes/edit',
    method: 'post',
    data
  })
}

// 中奖记录-现金重试打款
export function getRecordRetryById(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/record/retry/' + data,
    method: 'get'
  })
}
